import { TApplicationState } from '../../types/referral/store';
import { IUserState } from '../../types/referral/user';

export const getReferralUserId = (state: TApplicationState): IUserState['userId'] => state.user.userId;

export const getReferralUserPhone = (state: TApplicationState): IUserState['phoneNumber'] => state.user.phoneNumber;
